// removed by extract-text-webpack-plugin
module.exports = {"component":"GfNYQS71773rCq61oBgIt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/PaymentMethod/paymentMethod.css
// module id = 1100
// module chunks = 2